export default "__VITE_ASSET__DYjfLp1t__"